import { isOfVariant } from 'variant';
import VError from 'verror';
import { CliError } from './cli-error.js';
import { isCliError } from './is-cli-error.js';
import { CliErrorCode, CliUserErrorCode } from './cli-error-codes.js';

function getFirstUserError(error: Error): CliError | null {
  if (isCliError(error) && isOfVariant(error.cliCode, CliUserErrorCode)) {
    return error;
  }

  const nestedError = VError.cause(error);

  return nestedError ? getFirstUserError(nestedError) : null;
}

export function normalizeError(error: unknown) {
  const cliError = isCliError(error)
    ? error
    : new CliError({
        code: CliErrorCode.UnknownFailure({ error }),
        cause: error,
      });

  const firstUserError = getFirstUserError(cliError);

  // If there's a nested user error in the chain, it doesn't matter if it is
  // being wrapped by other errors later. When throwing such error, the intent
  // is always to show that error to the user, not any wrapping errors.
  return firstUserError ?? cliError;
}
